/**
 * XEP-0280 carbons copy your other resources' traffic to this one:
 *
 * ```
    <message to="9250@acme/web" from="9250@acme" type="chat">
      <sent xmlns="urn:xmpp:carbons:2">
        <forwarded xmlns="urn:xmpp:forward:0">
          <message to="10623@acme" from="9250@acme/other-tab" type="chat" id="out-1"
                   xmlns="jabber:client">
            <body>sent from my other tab</body>
          </message>
 * ```
 *
 * `<sent>` is something you sent elsewhere, `<received>` a copy of something
 * addressed to you. The envelope is you-to-you either way; the routing that
 * names a conversation is on the forwarded message.
 */
import type { Element as XmlEl } from "@xmpp/xml"
import { NS_CLIENT, NS_DELAY, NS_FORWARD } from "../../constants"
import { hoist } from "../../xmlUtils"
import { carbonPayload } from "./payload"

/** The forwarded message, or null when this isn't a carbon. */
export function unwrapCarbon(xml: XmlEl): XmlEl | null {
  const forwarded = carbonPayload(xml)?.getChild("forwarded", NS_FORWARD)
  if (!forwarded) return null

  const message = forwarded.getChild("message", NS_CLIENT)
  if (!message) return null

  hoist(forwarded, message, "delay", NS_DELAY)

  return message
}
